import * as React from "react";
import {
  Typography,
  Button,
  MenuItem,
  Theme,
  makeStyles,
  createStyles,
  Menu,
  Divider,
  Hidden,
} from "@material-ui/core";
import { LocalCache } from "../../helpers/cache";
import { useHistory } from "react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import UserPicture from "../UserPicture";
import { SCACHE_USER } from "../../core/constants/cacheKeys";

type Props = { name?: string };

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonRoot: {
      "height": theme.mixins.toolbar.minHeight,

      "& .MuiButton-label": {
        height: "100%",
      },

      "& .nameWrapper": {
        "display": "flex",
        "alignItems": "center",
        "marginRight": theme.spacing(1),

        "& .divider": {
          height: "2em",
          marginRight: theme.spacing(2),
        },
      },
    },
  })
);

function UserMenu(props: Props) {
  const { name } = props;

  const classes = useStyles();

  const lCache = new LocalCache();
  const history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickLogout = () => {
    lCache.delete("user");
    lCache.delete("bearer-token");
    lCache.delete(SCACHE_USER);
    // Redirect to initial page
    history.push("/");
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        className={classes.buttonRoot}
        onClick={handleToggle}
        aria-label="Menu do Usuário"
        aria-haspopup="true"
      >
        <div className={"nameWrapper"}>
          <Hidden xsDown>
            <Divider className={"divider"} orientation="vertical" />
            <Typography variant="body1">{name ? name.split(" ")[0] : "Usuário"}</Typography>
          </Hidden>
        </div>

        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}

        <UserPicture name={name} />
      </Button>
      <Menu
        id="menu-appbar"
        keepMounted
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem onClick={handleClickLogout}>Log Out</MenuItem>
      </Menu>
    </>
  );
}

export default UserMenu;
